import { Box, useMediaQuery, useTheme, IconButton, AppBar, Toolbar } from "@mui/material";
import { Menu as MenuIcon } from "@mui/icons-material";
import { Outlet } from "react-router-dom";
import { DrawerDesktop } from "../navigation/DrawerDesktop";
import { DrawerMobile } from "../navigation/DrawerMobile";
import { Logo } from "../logo/Logo";
import { useDrawer } from "src/utils/useDrawer";

/**
 * Main application layout with navigation drawer.
 *
 * Features:
 * - Responsive navigation (permanent drawer on desktop, temporary on mobile)
 * - Mobile: App bar with menu button
 * - Desktop: Permanent collapsible sidebar
 * - Content area adjusts based on drawer state
 */
export function AppLayout() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const { toggle } = useDrawer();

  return (
    <Box sx={{ display: "flex", minHeight: "100vh" }}>
      {/* Mobile App Bar */}
      {isMobile && (
        <AppBar position="fixed" sx={{ zIndex: theme.zIndex.drawer + 1 }}>
          <Toolbar>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="start"
              onClick={toggle}
              sx={{ mr: 2 }}
            >
              <MenuIcon />
            </IconButton>
            <Logo height={40} dark />
          </Toolbar>
        </AppBar>
      )}

      {/* Navigation Drawers */}
      {isMobile ? <DrawerMobile /> : <DrawerDesktop />}

      {/* Main Content Area */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: { xs: 1, md: 3 },
          minWidth: 0,
          overflow: "hidden",
          mt: isMobile ? "64px" : 0, // Account for mobile app bar
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
}
